// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileBlockModal_wrapper__Ui91t"};